import { AlertIcon, Alert, AlertProps, AlertDescription } from '@chakra-ui/core'
import React from 'react'

type CustomAlertProps = {
  withIcon?: boolean
} & AlertProps

const CustomAlert: React.FC<CustomAlertProps> = ({ children, status, withIcon, ...rest }) => {
  return (
    <Alert status={status || 'error'} bg={status === 'success' ? 'green.50' : undefined} {...rest}>
      {withIcon && <AlertIcon />}
      <AlertDescription maxWidth="sm">
        {children || 'There was an error processing your request'}
      </AlertDescription>
    </Alert>
  )
}

CustomAlert.defaultProps = {
  status: 'error',
  my: 1,
  borderRadius: 'md',
  width: '100%',
  padding: 4
}

export default CustomAlert
